import React from "react";
import PropTypes from "prop-types";
//Material imports
import Grid from "@mui/material/Grid";
//Limitless imports
import Typography from "@limitless/modern/data-display/typography/Typography";
const LandingRichText = ({
  content
}) => {
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    wrap: "nowrap"
  }, /*#__PURE__*/React.createElement(Typography, {
    dangerouslySetInnerHTML: {
      __html: content.text
    },
    variant: "body2"
  }));
};
export default LandingRichText;
LandingRichText.propTypes = {
  content: PropTypes.object.isRequired
};